import usePosition from "@/hooks/usePosition"

const Tel = () => {
  const { isChina } = usePosition()

  return <a href={`tel:${isChina ? "" : "+86"}4006882023`}>400 688 2023</a>
}

export default Tel